import React from 'react';
import PropTypes from 'prop-types';
import AvailabilitySiteTypeItem from './AvailabilitySiteTypeItem';

const propTypes = {
    name: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    colorSupport: PropTypes.oneOf(["01", "02", "03", "04"]).isRequired
};

export default class BaseAvailabilitySiteType extends React.Component {
    render() {
        return (
            <AvailabilitySiteTypeItem
                name={this.props.name}
                icon={this.props.icon}
                colorSupport={this.props.colorSupport}
                key={this.props.name} />
        );
    }
}

BaseAvailabilitySiteType.propTypes = propTypes;
